import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=5c8261d4&scoped=true&lang=pug&"
import script from "./LoginHeader.vue?vue&type=script&lang=ts&"
export * from "./LoginHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=5c8261d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8261d4",
  null
  
)

export default component.exports